import { createTheme } from '@mui/material/styles'

// Shared MUI theme for the public resources catalog. Pulls brand colors and
// typography from edpro.ua so the catalog feels like part of the main site.
const EDPRO_YELLOW = '#f6b407'
const EDPRO_TEXT = '#1a1a1a'
const EDPRO_MUTED = '#5a5d63'
const EDPRO_SURFACE = '#f8f8f8'

const theme = createTheme({
  palette: {
    primary: { main: EDPRO_YELLOW, contrastText: EDPRO_TEXT },
    secondary: { main: '#485980' },
    background: { default: EDPRO_SURFACE, paper: '#ffffff' },
    text: { primary: EDPRO_TEXT, secondary: EDPRO_MUTED },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"Lato", "Helvetica Neue", Arial, sans-serif',
    h4: { fontFamily: '"Nunito", sans-serif', fontWeight: 700 },
    h5: { fontFamily: '"Nunito", sans-serif', fontWeight: 700 },
    h6: { fontFamily: '"Nunito", sans-serif', fontWeight: 700 },
    button: { fontFamily: '"Nunito", sans-serif', fontWeight: 700, textTransform: 'none' },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: EDPRO_TEXT,
        },
      },
    },
  },
})

export default theme
